import NationalEducationPage from "components/NationalEducationPage";

export default function Home() {
  return <NationalEducationPage />;
}
